import styled, { css } from "styled-components";
import { Heading, KeyButton, Text, TypedCarousel } from "../services/visualLibraryService";
import { directions } from "../services/i18nService";

export const HeadingStyled = styled(Heading)`
  margin-bottom: ${props => props.theme.spacing.medium};
  margin-top: 0;
  text-transform: capitalize;
  font-weight: ${props => props.theme.font.weight.regular};
`;

export const ContainerStyled = styled.div`
  display: flex;
  ${props => props.userLogged && `justify-content: space-around;`}
  justify-content: space-between;
  height: 100%;
`;

// ShadowStyled - Mixin
export function shadowStyled(position, positionValue = 0, height, color, opacity = 1, zIndex = 5) {
  return `
    width: 100%;
    height: ${height};
    position: absolute;
    content: "";
    background: linear-gradient(to ${
      position === "top" ? "bottom" : "top"
    }, rgba(${color},1) 0%, rgba(${color},0) 100%);
    z-index: ${zIndex};
    ${position}: ${positionValue};
    opacity: ${opacity};
  `;
}

export const detailBackgroundStyled = {
  styles: css`
    &::before {
      width: 100%;
      height: 100%;
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      background-image: url(${props => props.url});
      background-blend-mode: lighten;
      background-size: cover;
      opacity: 0.1;
      background-color: rgba(8, 33, 37, 0.9);
    }
  `
};

// Common styles for Login - Signup - Redeem Voucher

export const BlockStyled = styled.div`
  & + & {
    flex: 1;
    margin-right: ${props =>
      props.theme.locale.dir === directions.RIGHT_TO_LEFT
        ? props.theme.baseLayoutPaddingBs * 3
        : props.theme.baseLayoutPaddingBs}%;
    margin-left: ${props =>
      props.theme.locale.dir === directions.RIGHT_TO_LEFT
        ? props.theme.baseLayoutPaddingBs
        : props.theme.baseLayoutPaddingBs * 3}%;
  }
`;

export const ButtonsGroupStyled = styled.div`
  display: flex;
  margin: ${props => props.theme.spacing.xsmall} 0;
`;

export const KeyButtonStyledBack = styled(KeyButton)`
  flex: 1;
  border: none !important;
`;

export const KeyButtonStyledNext = styled(KeyButtonStyledBack)`
  flex: 2.1;
`;

export const TextStyled = styled(Text)`
  margin-top: ${props => props.theme.spacing.small};
  color: ${props => props.theme.color.greyLight};
`;

export const TypedCarouselStyled = styled(TypedCarousel)`
  opacity: 0.75;
  transition: opacity 0.2s linear;
  will-change: opacity;
  /* TODO: Remove this when we change the carousel */
  .ReactVirtualized__Grid {
    will-change: initial !important;
  }
  &.focused {
    opacity: 1;
  }

  & .Styled__ImageContainerStyled-t5q7es-1 {
    display: flex;
    justify-content: center;
    & img {
      width: ${props => (props.type === "channels" ? "auto" : "100%")};
      height: 100%;
    }
  }
`;
